import React from 'react';

function AnglesAwpText() {
    return(
        <div className="GuideTextPara">
            <h5>Angles.</h5>
            <p>The importance of knowing your angles can't be underestimated. I find it to be just as important to know your angles as it is to hit your shots. Knowing how to position yourself in an angle that puts you in the best position to be effective is crucial to being a successful awper. When it comes to holding an angle, you have to know exactly what you're holding and what you're able to see while also being aware from where you can be seen from. Take a third person point of view when it comes to holding an angle. If you're exposed to a position that you can't see, you've putting yourself in a risky situation.   </p>
        </div>
    )
}

export default AnglesAwpText;